<template>
  <main>
    <v-container fluid fill-height>
      <v-layout grid align-center justify-center>
        <v-container grid-list-xl text-xs-center>
        <v-layout row wrap>
          <v-flex xs12>
            <img src="/static/img/v.png" alt="Cortexial" class="xs-12">
          </v-flex>

          <v-flex xs12 sm8 offset-sm2 md4 offset-md4>
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-text-field label="E-mail" autocomplete="username" v-model="email" :rules="emailRules" required ></v-text-field>
              <v-text-field label="Password" autocomplete="current-password" v-model="password" min="8" counter required :append-icon="passwordHidden ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (passwordHidden = !passwordHidden)" :type="passwordHidden ? 'password' : 'text'" :rules="passwordRules"></v-text-field>
              <v-btn large round color="secondary" @click="loginUser" :disabled="!valid || AppState.loading" > Login </v-btn>
            </v-form>
          </v-flex>
          <v-flex xs12>
            <div class="red--text">
              {{ errorMessage }}
            </div>
          </v-flex>

          <v-flex xs12>
            <a href="#" class="red--text" @click.prevent.stop="showRegistration()">Register for an account</a>
          </v-flex>
        </v-layout>
        </v-container>
      </v-layout>
    </v-container>
  </main>
</template>

<script>
import AppState from "../util/AppState";
import { FirebaseAuth } from "../firebase";

export default {
  /* eslint-disable no-useless-escape */
  /* eslint-disable no-mixed-operators */
  data() {
    return {
      AppState,
      valid: true,
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      password: "",
      passwordHidden: true,
      passwordRules: [
        v => (v && v.length >= 8) || "Password must at least 8 characters"
      ],
      errorCode: "",
      errorMessage: ""
    };
  },
  methods: {
    loginUser() {
      this.errorCode = "";
      this.errorMessage = "";
      if (this.$refs.form.validate()) {
        FirebaseAuth.signInWithEmailAndPassword(
          this.email,
          this.password
        ).catch(error => {
          AppState.error.text = error.message;
          AppState.error.show = true;
        });
      }
    },
    showRegistration() {
      this.$emit("showRegistration");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/AuthLogin.vue